<script>
    import SmartField from '../../../components/SmartField/SmartField.svelte'
    import SmartSelect from '../../../components/SmartField/SmartSelect.svelte'

    export let data
</script>

<style>
    .meta-editor {
        padding: 7px 10px;
        margin-top: 5px;
        background-color: #fff;
        border-radius: 3px;
        position: relative;
        z-index: 21;
    }
</style>

<div class="meta-editor">
    <SmartField 
        type="textarea" 
        name="description" 
        label="Descrizione" 
        bind:value={data.description} />
    <SmartField 
        type="textarea" 
        name="notes" 
        label="Note" 
        bind:value={data.notes} />
    <SmartSelect 
        name="type" 
        bind:value={data.type} 
        options={[{ value: 0, text: 'Ordinario' }, { value: 1, text: 'Straordinario' }]} />
</div>